import React from 'react'

const FinanceiroRoutes = [
    {
        path: '/financeiro/administrativo',
        exact: true,
        component: React.lazy(() => import('./administrativo/geral/lista/TableFinAdm')),
    },
    {
        path: '/financeiro/administrativo/novo',
        exact: true,
        component: React.lazy(() => import('./administrativo/geral/form/Form')),
    },
    {
        path: '/financeiro/administrativo/individual/visualizar',
        exact: true,
        component: React.lazy(() => import('./administrativo/individual/visualizar/Form')),
    },
    {
        path: '/financeiro/administrativo/individual/editar',
        exact: true,
        component: React.lazy(() => import('./administrativo/individual/editar/Form')),
    },
    {
        path: '/financeiro/administrativo/faturas',
        exact: true,
        component: React.lazy(() => import('./administrativo/faturas/lista/Listar')),
    },
    
]

export default FinanceiroRoutes
